export default __webpack_public_path__ + "static/media/gw5.8606b494.webp";